// extracted by mini-css-extract-plugin
module.exports = {"TopSide":"TopSide-module--TopSide--2byZ_","red":"TopSide-module--red--2wpWg"};